export {
  APPLE_PRODUCT_IDS,
  GOOGLE_PRODUCT_IDS,
  GOOGLE_VERIFY_ENDPOINT,
  GOOGLE_PLAY_MANAGE_SUBSCRIPTIONS_URL,
  BUNDLE_ID,
  FEEDBACK_FORM_URL,
  TERMS_AND_CONDITIONS_URL,
  AUTH_SERVER_URL,
  PASSWORD_RESET_URL,
  PF_SERVER_URL,
  PARAPASS_SERVER_URL,
  PF_CONFIG_SERVER_URL,
  PLUS_DEEPLINK_URL,
  PARAPASS_DEEPLINK_URL,
  HCPC_URL,
  CLASS_APPS_URL,
  CLASS_PARAFOLIO_WEB_SUBSCRIPTION_URL,
  CLASS_PARAFOLIO_URL,
  CLASS_TERMS_URL,
  PF_FAQ_URL,
  PF_FEATURES_URL,
  CONFIG_BUCKET_BASE,
} from "@environment/env";

export const MAX_FONT_SIZE = 10;
export const DEFAULT_FONT_SIZE = 0;
export const MIN_FONT_SIZE = -5;

export const MIN_LINE_HEIGHT = 1;
export const DEFAULT_LINE_HEIGHT = 1.5;
export const MAX_LINE_HEIGHT = 3;

export const DEV_TOKEN =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9eyJ1aWQiOiIyNDg1NDkiLCJjbGFpbXMiOnsiY29udGFjdElEIjoiMjQ4NTQ5In0sImlhdCI6MTU4Mjg4ODI2N30HC2iY4co2OvTc9yKZ7rNRkFORX";

export const DEV_CONTACT_ID = ""; // Debugging customer
export const DEV_SUPERUSER = 602678;

// export const DATA_REFRESH_INTERVAL = 300_000; // 5 minutes
export const DATA_REFRESH_INTERVAL = 10_000; // 10 seconds
// export const USAGE_DATA_REFRESH_INTERVAL = 5000; // 5 seconds
export const USAGE_DATA_REFRESH_INTERVAL = 60_000; // 1 minute
// export const USER_DATA_REFRESH_INTERVAL = 300_000; // 5 minutes
export const USER_DATA_REFRESH_INTERVAL = 30_000; // 30 seconds
// export const PROGRAM_DATA_REFRESH_INTERVAL = 5000; // 5 seconds
export const PROGRAM_DATA_REFRESH_INTERVAL = 300_000; // 5 minutes

export const EVIDENCE_ACCEPTED_FILE_TYPES = [
  ".pdf",
  ".odt", // OpenDocument Text
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  "image/*", // All image file types
  "audio/*", // All audio file types
  "video/*", // All video file types
  ".csv",
  ".rtf",
  ".rtx",
  ".eml", // Email
];
export const EVIDENCE_MAX_FILE_SIZE = 150;

export const CERTIFICATE_ACCEPTED_FILE_TYPES = [
  ".pdf",
  ".odt", // OpenDocument Text
  ".doc",
  ".docx",
  "image/*", // All image file types
  ".csv",
  ".rtf",
  ".rtx",
];

export const CERTIFICATE_MAX_FILE_SIZE = 85;

export const TRUST_BACKGROUND_COLOUR_VARIANTS: { [key: string]: string } = {
  SWASFT: "!bg-SWASFT",
  NWAS: "!bg-NWAS",
  LAS: "!bg-LAS",
  NEAS: "!bg-NEAS",
  YAS: "!bg-YAS",
  REN: "!bg-REN",
  TEST: "!bg-NEAS",
};
